import { styled } from "styled-components";
const MultiSliderWrapper = styled("div")(({ theme }) => ({
  color: theme.fontSize.color,
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  margin: "0 8px",
  outline: "transparent",
  position: "relative"
}));
const MultiSliderImpl = styled("div")(
  {
    cursor: "pointer",
    position: "relative",
    "&:active": {
      cursor: "grabbing"
    }
  },
  ({ disabled }) => disabled ? {
    pointerEvents: "none"
  } : void 0
);
const MultiSliderRail = styled("div")({
  height: 20,
  position: "relative",
  "&::after": {
    backgroundColor: "rgba(0,0,0,0.05)",
    borderRadius: 2,
    content: '""',
    height: 4,
    left: 0,
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)"
  }
});
const MultiSliderTrack = styled("div")(
  ({ theme }) => ({
    backgroundColor: theme.color.blue6,
    height: 4,
    margin: "auto",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)"
  }),
  ({ left = 0 }) => ({ left }),
  ({ right = 0 }) => ({ right }),
  ({ disabled }) => disabled ? {
    backgroundColor: "transparent"
  } : void 0
);
export {
  MultiSliderImpl,
  MultiSliderRail,
  MultiSliderTrack,
  MultiSliderWrapper
};
